import * as React from 'react';
import { useSelector } from 'react-redux';
import { waveInteractionDisabledSelector } from '../../delineation/selectors/delineation.selectors';
import { selectedIdsSelector } from '../../wave/selectors/wave.selectors';
import { Wave as WaveType } from '../../wave/types/wave.type';
import { useStrip } from '../hooks/useStrip';
import { useStripWindow } from '../hooks/useStripWindow';
import { EventHandler, StripInteractions } from './StripInteractions';
import { Wave } from './Wave';
import { TagSelectionMode } from '../../wave/types/tag.type';

interface Props {
  handler: EventHandler;
  background: WaveType[];
  foreground: WaveType[];
  optionalTagSelectionMode?: TagSelectionMode;
}

export const Waves: React.FC<Props> = ({
  handler,
  background,
  foreground,
  optionalTagSelectionMode,
}) => {
  const disableInteractions = useSelector(waveInteractionDisabledSelector);
  const { onset, offset } = useStrip();
  const { start: minOffset, end: maxOnset } = useStripWindow();
  const selectedWaveIds = useSelector(selectedIdsSelector);
  const filterVisible = (wave: WaveType) => {
    const isWithinWindow =
      wave.offset + offset > minOffset && wave.onset - onset < maxOnset;
    const isSelected = selectedWaveIds.includes(wave.id);
    const isLinkedToSelected =
      wave.link && selectedWaveIds.includes(wave.link.waveId);
    return isWithinWindow || isSelected || isLinkedToSelected;
  };

  const renderedBackgroundWaves = background
    .filter(filterVisible)
    .map((wave) => (
      <Wave
        key={wave.id}
        waveId={wave.id}
        optionalTagSelectionMode={optionalTagSelectionMode}
      />
    ));

  const renderedForegroundWaves = foreground
    .filter(filterVisible)
    .map((wave) => (
      <Wave
        key={wave.id}
        waveId={wave.id}
        optionalTagSelectionMode={optionalTagSelectionMode}
      />
    ));

  return (
    <StripInteractions eventHandler={handler} disabled={disableInteractions}>
      {renderedBackgroundWaves}
      {renderedForegroundWaves}
    </StripInteractions>
  );
};
